










































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Chips from '@/components/controls/Chips.vue';
import {getNow, getNowWithInterval} from '@/utils/dateTimeUtils';
import {DateTimeInterval} from '@/utils/dateTimeItervalUtils';
import {remove} from 'lodash';
import {ComparedDiagramData, DiagramData} from '@/interfaces/diagrams';
import Loading from '@c/controls/Loading.vue';
import userSettingsStoreModule from '@/store/modules/userSettingsModule';
import {SelectedChipsData} from '@c/controls/interfaces';
import SignalDiagram from './SignalDiagram.vue';
import {SignalDiagramData, TrendOptions} from './interfaces';
import {getYAxisName} from './utils';
import {getApiStore} from './utils';
import {addSignalSubscription} from '@/utils/socketUtils';

const getDiagramSubscriptionParams = (diagram: SignalDiagramData) => ({
  moduleType: diagram.moduleType,
  moduleGUID: diagram.moduleGUID,
  alias: diagram.measurement.alias,
  eventType: diagram.measurement.eventType,
});

@Component({
  components: {
    SignalDiagram,
    Chips,
    Loading,
  },
})
export default class SignalDiagramBox extends Vue {
  data: ComparedDiagramData = {
    mainDiagram: {data: [], yAxis: {name: '', units: ''}, name: '', id: '', visible: true},
    comparedDiagrams: [],
  };

  chartData: DiagramData = {
    data: [],
    yAxis: {name: '', units: ''},
    name: '',
    id: '',
    visible: true,
  };
  comparedChartsData: DiagramData[] = [];

  @Prop({required: false})
  trend!: TrendOptions | null;

  // Показатель возможности подгрузить спектр по курсору времени
  @Prop({required: false, default: false})
  isCanObtainSpectrum!: boolean;
  obtainSpectrum(ts: number | undefined | null) {
    this.$emit('obtainSpectrum', ts);
  }

  topLevelChart: any = null;
  bottomLevelChart: any = null;
  topLevel: any = null;
  bottomLevel: any = null;

  // Изначально установленный в chip период
  period: {name: string; duration: any; intervalCustom?: DateTimeInterval} = {
    name: 'час',
    duration: {hours: 1},
  };
  periods: {name: string; duration: any; intervalCustom?: DateTimeInterval}[] = [
    {
      name: '5 минут',
      duration: {minutes: 5},
    },
    {name: 'час', duration: {hours: 1}},
    {
      name: '12 часов',
      duration: {hours: 12},
    },
    {name: 'сутки', duration: {days: 1}},
    {name: '30 дней', duration: {days: 30}},
    {name: 'интервал', duration: null, intervalCustom: {startDateTime: 0, endDateTime: 0}},
  ];

  // диапазон дат для чипса с интервалом
  //selectedInterval: DateTimeInterval | null = null;

  selectedChipsData: SelectedChipsData = {index: 1, isCustom: false, update: true};

  // Показатели загрузки данных и ошибки загрузки данных
  loading = false;
  error = false;

  // Диаграмма
  @Prop({required: true})
  diagram!: SignalDiagramData;

  //Ключ для обновления размеров диаграммы
  @Prop({required: false, type: Number, default: 0})
  resizedKey!: number;

  // Флаг сохранения настроек, если false, храним настройки во временной области localstorage
  @Prop({required: false, default: true})
  saveSettings!: boolean;

  shouldSaveSettings = this.saveSettings;

  // Список диаграмм для сравнения
  @Prop({required: false, default: null})
  comparedDiagrams!: SignalDiagramData[] | null;

  @Watch('comparedDiagrams')
  async onChangeComparedDiagrams(
    comparedDiagrams: SignalDiagramData[] | null,
    oldComparedDiagrams: SignalDiagramData[] | null,
  ) {
    try {
      this.loading = true;
      this.error = false;
      const startDateTime = this.xSoftMin;
      const endDateTime = this.xSoftMax;
      //удаляем подписки для старых диаграмм, нам они уже не нужны
      this.removeWSSubscriptionsForDiagrams(oldComparedDiagrams);
      //удаляем для текущих диаграм
      this.removeWSSubscriptions();
      const comparedData = await this.requestComparedChartsConfigData({startDateTime, endDateTime});
      this.defineComparedCharts(comparedData);
      this.setData();

      if (this.liveUpdateStatus) this.addWSSubscriptions();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  onSyncChips(value: SelectedChipsData) {
    if (
      (value.isCustom &&
        this.selectedChipsData.isCustom &&
        value.interval?.startDateTime == this.selectedChipsData.interval?.startDateTime &&
        value.interval?.endDateTime == this.selectedChipsData.interval?.endDateTime) ||
      (!value.isCustom &&
        !this.selectedChipsData.isCustom &&
        value.interval === this.selectedChipsData.interval)
    )
      return;

    if (value.isCustom)
      this.period = {
        ...(this.periods[value.index as any] as any),
        intervalCustom: {...value.interval},
      };
    else this.period = this.periods[value.index as any] as any;
  }

  // Минимальное значение масштаба по оси X (мс)
  xMinScaleValue = 1000;

  // Показатель сдвига графика при обновлении данных
  isShift = true;

  // Значение soft min и soft max оси x, нужно для того, чтобы при отсутствии данных показывать полный период
  xSoftMin: any = null;
  xSoftMax: any = null;

  // Показатель того, что применен зум, нужно для корректной работы с сокетами
  isInZoom = false;

  // Статус "живого" обновления
  liveUpdateStatus = true;

  //цвет графика из сохраненных настроек если есть
  color = '';

  isYLogAxis = false;

  // переключение на чипс со справочными интервалами
  @Watch('period')
  async onChangePeriod() {
    if (this.period.name) {
      this.isInZoom = false;

      this.removeWSSubscriptions();

      const endDateTime =
        this.period?.intervalCustom && this.period.intervalCustom.endDateTime
          ? this.period.intervalCustom.endDateTime
          : getNow();
      const startDateTime =
        this.period?.intervalCustom && this.period.intervalCustom.startDateTime
          ? this.period.intervalCustom.startDateTime
          : getNowWithInterval(this.period.duration, 'minus');

      const index = this.periods.findIndex(x => x.name === this.period.name);
      this.selectedChipsData = {
        index,
        interval: {startDateTime, endDateTime},
        isCustom: this.period.duration === null,
      };
      this.defineInitialChartState(startDateTime, endDateTime);
    }
  }

  async created() {
    this.color = this.diagram.color ?? '';
    if (this.diagram.isYLogAxis !== undefined) {
      this.isYLogAxis = this.diagram.isYLogAxis;
    }

    const endDateTime = getNow();
    const startDateTime = this.trend?.data
      ? this.trend.data[0][0]
      : getNowWithInterval(this.period.duration, 'minus');
    if (this.trend?.data) {
      this.period = this.periods[4];
      this.period.intervalCustom = {startDateTime: startDateTime, endDateTime: endDateTime};
    }
    this.defineInitialChartState(startDateTime, endDateTime);
  }

  async defineInitialChartState(startDateTime: number, endDateTime: number) {
    this.xSoftMin = startDateTime;
    this.xSoftMax = endDateTime;

    try {
      this.loading = true;
      this.error = false;
      const data = await getApiStore(this.diagram.moduleType).getSignal({
        id: this.diagram.moduleId,
        dateInterval: {startDateTime, endDateTime},
        fieldAlias: this.diagram.measurement.alias,
        statType: this.diagram.measurement.eventType,
      });

      const comparedData = await this.requestComparedChartsConfigData({startDateTime, endDateTime});

      this.defineMainChartAndLevel(data);
      this.defineLevelCharts(this.xSoftMin, this.xSoftMax);
      this.defineComparedCharts(comparedData);
      this.setData();

      // не подключаемся если нельзя из-за режима или в чипсах выбран интервал
      if (this.liveUpdateStatus && !this.selectedChipsData.isCustom) this.addWSSubscriptions();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async returnInitialStateChart() {
    if (this.isInZoom) {
      const endDateTime = this.selectedChipsData.interval?.endDateTime ?? getNow();
      const startDateTime =
        this.selectedChipsData.interval?.startDateTime ??
        getNowWithInterval(this.period.duration, 'minus');
      this.defineInitialChartState(startDateTime, endDateTime);
      this.isInZoom = false;
    }
  }

  async onChartZoom(dateInterval: DateTimeInterval) {
    this.isInZoom = true;
    this.removeWSSubscriptions();

    const startDateTime = dateInterval.startDateTime as number;
    const endDateTime = dateInterval.endDateTime as number;
    this.xSoftMin = startDateTime;
    this.xSoftMax = endDateTime;

    try {
      this.loading = true;
      this.error = false;

      const data = await getApiStore(this.diagram.moduleType).getSignal({
        id: this.diagram.moduleId,
        dateInterval: {startDateTime, endDateTime},
        fieldAlias: this.diagram.measurement.alias,
        statType: this.diagram.measurement.eventType,
      });

      const comparedData = await this.requestComparedChartsConfigData({startDateTime, endDateTime});

      if (!data.dataSet.length) {
        data.dataSet = [
          {x: dateInterval.startDateTime as number, y: 0},
          {x: dateInterval.endDateTime as number, y: 0},
        ];
      }

      this.defineMainChartAndLevel(data);
      this.defineLevelCharts(this.xSoftMin, this.xSoftMax);
      this.defineComparedCharts(comparedData);
      this.setData();
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  //Обработчик события изменения статуса "живого" обновления
  async onLiveUpdateStatusChanged(status: boolean) {
    this.liveUpdateStatus = status;
    //обновляем график целиком
    if (status) {
      const endDateTime = this.selectedChipsData.interval?.endDateTime ?? getNow();
      const startDateTime =
        this.selectedChipsData.interval?.startDateTime ??
        getNowWithInterval(this.period.duration, 'minus');
      this.defineInitialChartState(startDateTime, endDateTime);
    } else this.removeWSSubscriptions();
  }

  //Запрос данных связанных графиков (TODO: лучше сделать методом на сервере)
  async requestComparedChartsConfigData(dateInterval: DateTimeInterval) {
    if (!this.comparedDiagrams) return null;
    const comparedChartsData: DiagramData[] = [];
    for (let i = 0; i < this.comparedDiagrams.length; ++i) {
      const diagram = this.comparedDiagrams[i];

      const data = await getApiStore(diagram.moduleType).getSignal({
        id: diagram.moduleId,
        dateInterval,
        fieldAlias: diagram.measurement.alias,
        statType: diagram.measurement.eventType,
      });

      comparedChartsData.push({
        data: data.dataSet,
        yAxis: {
          name: getYAxisName(diagram),
          units: diagram.measurement.unit != '-' ? diagram.measurement.unit : '',
        },
        name: diagram.name ? diagram.name : '',
        id: diagram.id,
        visible: diagram.visible,
      });
    }
    return comparedChartsData;
  }

  //данные для основого графика и пределы
  defineMainChartAndLevel(data: any) {
    this.chartData = {
      data: data.dataSet,
      yAxis: {
        name: getYAxisName(this.diagram),
        units: this.diagram.measurement.unit != '-' ? this.diagram.measurement.unit : '',
      },
      name: this.diagram.name ? this.diagram.name : '',
      id: this.diagram.id,
      visible: this.diagram.visible,
    };
    this.topLevel = this.diagram.topBoundary;
    this.bottomLevel = this.diagram.bottomBoundary;
  }

  //данные для сравниваемых графиков
  defineComparedCharts(data: any[] | null) {
    if (!data) return;
    this.comparedChartsData = data;
  }

  //сами графики уровней
  // TODO вернуть поиск графиков по алиасу
  defineLevelCharts(xMin: number, xMax: number) {
    if (this.topLevel) {
      this.topLevelChart = [
        {x: xMin, y: this.topLevel},
        {x: xMax, y: this.topLevel},
      ];
    }
    if (this.bottomLevel) {
      this.bottomLevelChart = [
        {x: xMin, y: this.bottomLevel},
        {x: xMax, y: this.bottomLevel},
      ];
    }
  }

  /*
    Действия при подписке на веб-сокет
  */
  subscribeConectionWS(diagram: SignalDiagramData, e: {data: string}) {
    const strParse = JSON.parse(e.data);

    if (!strParse) return;

    const {
      value,
      timestamp,
      module_identifier,
      module_alias,
      event_type,
    }: {
      value: number;
      timestamp: number;
      module_identifier: string;
      module_alias: string;
      event_type: string;
    } = strParse;

    const currentTimestamp = new Date().getTime();
    if (
      module_identifier !== diagram.moduleGUID ||
      module_alias !== diagram.measurement.alias ||
      event_type !== diagram.measurement.eventType ||
      currentTimestamp - timestamp > 60 * 1000
    ) {
      return;
    }
    let chartData: any = null;
    if (diagram.id === this.diagram.id) chartData = this.chartData;
    else {
      if (!this.comparedDiagrams) return;
      chartData = this.comparedChartsData[this.comparedDiagrams.indexOf(diagram)];
    }
    //получаем границу временного окна и фильтруем точки
    if (this.isShift) {
      const startDateTime = getNowWithInterval(this.period.duration, 'minus');
      this.xSoftMin = startDateTime;
      remove(chartData.data, (p: any) => p.x < startDateTime);
    }

    const xValue = timestamp;
    chartData.data.push({x: xValue, y: value});
    this.xSoftMax = xValue;
    this.defineLevelCharts(this.xSoftMin, this.xSoftMax);
    this.setData();
  }

  setData() {
    this.data = {mainDiagram: this.chartData, comparedDiagrams: this.comparedChartsData};
  }

  beforeDestroy() {
    this.removeWSSubscriptions();
  }

  /*Работа с веб-сокетами*/

  // Добавляем необходимые подписки

  addWSSubscriptions() {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }
    if (!this.$dataSocketManager.hasSubscription(this.diagram.id)) {
      const params = getDiagramSubscriptionParams(this.diagram);
      const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
      const subscriptionFunction = (socket: WebSocket) =>
        addSignalSubscription.call(this, socket, params);

      this.$dataSocketManager.addSubscription(
        this.diagram.id,
        subscrName,
        subscriptionFunction,
        this.subscribeConectionWS.bind(this, this.diagram),
      );
    }

    //добавляем новые
    this.comparedDiagrams?.forEach(d => {
      if (!this.$dataSocketManager.hasSubscription(d.id)) {
        const params = getDiagramSubscriptionParams(d);
        const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
        const subscriptionFunction = (socket: WebSocket) =>
          addSignalSubscription.call(this, socket, params);

        this.$dataSocketManager.addSubscription(
          d.id,
          subscrName,
          subscriptionFunction,
          this.subscribeConectionWS.bind(this, d),
        );
      }
    });
  }

  // удаляем все подписки
  removeWSSubscriptions() {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }
    this.$dataSocketManager.removeSubscription(this.diagram.id);
    if (this.comparedDiagrams) {
      this.comparedDiagrams.forEach(d => this.$dataSocketManager.removeSubscription(d.id));
    }
  }

  removeWSSubscriptionsForDiagrams(diagrams: SignalDiagramData[] | null) {
    if (!this.$dataSocketManager) {
      console.log('No socket manager');
    }
    if (diagrams) {
      diagrams.forEach(d => this.$dataSocketManager.removeSubscription(d.id));
    }
  }
  /**/

  async onUpdateUserSettings(settings: any) {
    const model = {
      pModuleId: this.diagram.moduleId,
      measurementId: this.diagram.measurement.id, // Почему-то было alias
      measurementType: this.diagram.measurement.type,
      color: settings.matchColor,
      isYLogAxis: settings.isYLogAxis,
    };
    if (this.shouldSaveSettings) {
      // TODO: заменить на сохранение в БД
      await userSettingsStoreModule.saveDiagramSettings(model);
    } else {
      // если не нужно сохранять, то держим настроки в localStore пока используем
      await userSettingsStoreModule.saveTempDiagramSettings(model);
    }
  }
}
